import MainLayout from "@/layouts/Main.vue";
import LoginLayout from "@/layouts/Login.vue";

import Login from "@/pages/Login.vue";
import Logout from "@/pages/Logout.vue";

import ServiceList from "@/pages/services/List.vue";
import ServiceView from "@/pages/services/View.vue";

import OrderList from "@/pages/orders/List.vue";
import OrderView from "@/pages/orders/View.vue";
import OrderAlbum from "@/pages/orders/Album.vue";

import ProfileView from "@/pages/profile/View.vue";
import ProfileMoneyRequest from "@/pages/profile/MoneyRequest.vue";

import StaticPage from "@/pages/static/Page.vue";


import Dashboard from "@/pages/Dashboard.vue";

let authPages = {
    path: "/auth",
    component: LoginLayout,
    name: "Authentication",
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/logout",
            name: "Logout",
            component: Logout
        }
    ]
};

let orderPages = {
    path: "/orders",
    component: MainLayout,
    name: "Order",
    redirect: "/orders/list",
    children: [
        {
            path: "list",
            component: OrderList,
            name: "Order list",
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: "view/:id",
            component: OrderView,
            name: "Order View",
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "view/:id/album",
            component: OrderAlbum,
            name: "Album View",
            meta: {
                requiresAuth: true
            }
        },
    ]
};


let profilePages = {
    path: "/profile",
    component: MainLayout,
    name: "Profile",
    redirect: "/profile/view",
    children: [
        {
            path: "view",
            component: ProfileView,
            name: "Profile list",
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: "money-request",
            component: ProfileMoneyRequest,
            name: "Profile money request",
            meta: {
                requiresAuth: true
            }
        }
    ]
};

let servicePages = {
    path: "/services",
    component: MainLayout,
    name: "Service",
    redirect: "/services/list",
    children: [
        {
            path: "list",
            component: ServiceList,
            name: "Services List",
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "view/:id",
            component: ServiceView,
            name: "Services View",
            meta: {
                requiresAuth: true
            }
        }
    ]
};

let staticPages = {
    path: "/static",
    component: MainLayout,
    name: "Static",
    children: [
        {
            path: "*",
            name: "Page",
            component: StaticPage
        },
    ]
};

const routes = [
    {
        path: "/",
        component: MainLayout,
        name: "Home",
        redirect: "/services",
        children: [
            {
                path: "dashboard",
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
        ],
    },
    authPages,
    servicePages,
    orderPages,
    profilePages,
    staticPages
];

export default routes;